module.exports = __webpack_public_path__ + "img/img66.1071b986.png";